export default __webpack_public_path__ + "static/media/token-icon-2.645722f2.svg";